import { v4 as createUuid } from "uuid";

import {
  carriedIdentity,
  currentIdentity,
  getSolvariSessionId,
  initCrossDomainLinker,
  sSessionStorage,
  storeSolvariSessionUuid,
} from "@solvari/utils";

import { initRootClient } from "@/client/rootClient";

function initSessionId(sessionType: SessionType) {
  if (sessionType === "new") {
    sSessionStorage.removeItem("argusEvents");
    const uuid = createUuid();
    storeSolvariSessionUuid(uuid);
    return uuid;
  }

  if (sessionType === "cross-domain") {
    const uuid = carriedIdentity().sessionUuid!;
    storeSolvariSessionUuid(uuid);
    return uuid;
  }

  return getSolvariSessionId()!;
}

// Once per page: the linker attaches document listeners with no guard.
function initArgus(clientId: string | null) {
  if (clientId === null) {
    return null;
  }

  const sessionType = getSessionType();
  const sessionUuid = initSessionId(sessionType);
  initCrossDomainLinker();

  const rootClientPromise = initRootClient(sessionType).flush();

  return { sessionUuid, clientId, rootClientPromise };
}

type SessionType = "cross-domain" | "new" | "same-domain";
function getSessionType(): SessionType {
  if (carriedIdentity().sessionUuid) {
    return "cross-domain";
  }

  if (currentIdentity().sessionUuid) {
    return "same-domain";
  }

  return "new";
}

export { getSessionType, initArgus };
export type { SessionType };
